import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import Picture from '../../Picture'
import LocaleLink from '../../Routes/LocaleLink'

class HomepageGuide extends Component
{
    container = React.createRef()
    parallax = React.createRef()

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.container.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(60 * delta - 300) + 'px'
    }

    render() {
        return (
            <section className="section-default section-guide" ref={this.container}>
                <div className="section-default-after section-guide-after" ref={this.parallax}/>
                <div className="container">
                    <div className="default-wrap guide-wrap">
                        <div className="default-img guide-img">
                            <Picture
                                src={require("../../../../images/man.png")}
                                webp={require("../../../../images/man.webp")} />
                        </div>
                        <div className="default-text guide-text">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.homepage.time_search"
                                    defaultMessage="Pas le temps de chercher un job ?"
                                />
                            </h2>
                            <p className="default-text-subtitle guide-text-subtitle">
                                <FormattedMessage
                                    id="portfolio.homepage.guide.subtitle"
                                    defaultMessage="Cerise sur le gateau"
                                />
                            </p>
                            <p className="default-text-paragraph guide-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.guide.paragraph_1"
                                    defaultMessage="Cerise sur le gateau"
                                />
                            </p>
                            <p className="default-text-paragraph guide-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.guide.paragraph_2"
                                    defaultMessage="Cerise sur le gateau"
                                />
                            </p>
                            <p className="default-text-paragraph guide-text-paragraph">
                                <FormattedMessage
                                    id="portfolio.homepage.guide.paragraph_3"
                                    defaultMessage="Cerise sur le gateau"
                                />
                            </p>
                            <LocaleLink to="/candidature-spontanee" className="btn btn-line-danger">
                                <FormattedMessage
                                    id="portfolio.homepage.find_for_you"
                                    defaultMessage="ON TROUVE POUR VOUS"
                                />
                            </LocaleLink>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default HomepageGuide;
